// @flow
import React from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import routerActions from '../../actions/router';
import searchParamsActions from '../../actions/searchParams';

import NoResultsBanner from '../NoResultsBanner/NoResultsBanner';

import {trigger, GENERIC_EVENT} from '../../utils/edapWrapper';

import type {Node} from 'react';

type DispatchProps = {
    filter: typeof routerActions.filter,
    resetInputParams: typeof searchParamsActions.resetInputParams
};

type Props = DispatchProps;

export function NoResultsBannerWithFilterButton(props: Props) {
    const buttonHandler = () => {
        trigger(GENERIC_EVENT, {
            eventcategory: 'search',
            eventaction: 'no results clear filters'
        });
        props.resetInputParams();
        props.filter();
    };
    const title = (
        <FormattedMessage
            id="noResultsBanner"
            description="No results banner"
            defaultMessage="No results"
        >
            {(message: Node): Node => message}
        </FormattedMessage>
    );
    const description = (
        <FormattedMessage
            id="noResultsBannerText"
            description="No results banner text"
            defaultMessage="Try removing filters or zoom out on the map to search a larger area."
        >
            {(message: Node): Node => message}
        </FormattedMessage>
    );
    const buttonLabel = (
        <FormattedMessage
            id="clearAllFilters"
            description="Clear all filter button label"
            defaultMessage="Clear all filters"
        />
    );

    return (
        <NoResultsBanner
            title={title}
            description={description}
            buttonLabel={buttonLabel}
            buttonHandler={buttonHandler}
        />
    );
}

const mapDispatchToProps = {
    resetInputParams: searchParamsActions.resetInputParams,
    filter: routerActions.filter
};

export default connect(
    null,
    mapDispatchToProps
)(NoResultsBannerWithFilterButton);
